import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import SchoolCombo from '../combos/SchoolCombo';
import { Col, Form, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';


export default function SmsApiKeys(props) {
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

    
    const [currentItem, setCurrentItem] = useState(null);
    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const LoadingRows = Array.from({length:5});

    const [apiKey, setApiKey] = useState("");
    const [verifyCode, setVerifyCode] = useState("");
    const [school, setSchool] = useState(null);
    const [searchSchool, setSearchSchool] = useState(null);
    const [searchApiKey, setSearchApiKey] = useState("");


    useEffect(() => {
      searchItems();
    }, []);

    const searchItems = function(){
      setLoading(true);    

      var params = {login:util.getTrustedUser(), lastIndex:0, pageSize:0, schoolId:searchSchool? searchSchool.id : "", apiKey:searchApiKey};
      var url = config.Server+`/basic/smsApiKey/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response is>", response);
                  
                  setItems(response);
                  setFilterItems(response);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
    }
    const addNewItem = function(){
      setCurrentItem(null);
      setApiKey("");
      setSchool(null);
      setEditFormVisible(true);
    }
    const onRowEditClick = function(row) {
      setCurrentItem(row);
      setApiKey(row.apiKey);
      setSchool(row.school);
      setEditFormVisible(true);        
    }
    const onRowDeleteClick = function(row) {
      setCurrentItem(row);
      setConfirmDeleteVisible(true);
    }

    const closeEditDialog = function(){
      setEditFormVisible(false);
    }
    const deleteItem = function(){
      setDeleting(true);
      var id = currentItem.id;
      var params = {login:util.getTrustedUser(), id:id};
      var url = config.Server+`/basic/smsApiKey/delete`;
        axios
            .post(url, params )
            .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  for(var i=0;i<tmp.length;i++){
                    if(tmp[i].id === id){
                      tmp.splice(i, 1);
                      break;
                    }
                  }
                  setCurrentItem(null);
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setDeleting(false);
                  setConfirmDeleteVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setDeleting(false);
              }
            })
            .catch(error => {
              setDeleting(false);
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }

    const checkDataEntry = function(){
        if((!school)||(school == null)||(school == null)){
            setErrorMessage("مدرسه را انتخاب کنید");
            setErorVisible(true);
            return false;
        }
        if(apiKey.trim().length < 36){
            setErrorMessage("کلید ارسال پیامک را وارد کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
      if(!checkDataEntry()) return;

      setSaving(true);
      var id = "";
      if(currentItem != null){
        id = currentItem.id;
      }
      var params = {login:util.getTrustedUser(), id:id, schoolId:school.id, apiKey:apiKey, email:"", userAlreadyExist:true};
      var url = config.Server+`/basic/smsApiKey/save`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  if(id === ""){
                    tmp.push(response);
                  }
                  else{
                    for(var i=0;i<tmp.length;i++){
                      if(tmp[i].id === id){
                        tmp[i] = {...response}
                        setCurrentItem(tmp[i]);
                        break;
                      }
                    }
                  }
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setSaving(false);
                  setEditFormVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{closeEditDialog()}} saving={saving} />
        )
    }
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "apiKey") setApiKey(val);
        else if(name === "searchApiKey") setSearchApiKey(val);
    }
    const onComboChange = function(name, value){
      var id = "";
      if(value)
        if(value.id)
          id = value.id;
      if(name == "school")setSchool(value);
      else if(name == "searchSchool")setSearchSchool(value);
      
    }
    const setRowActions = function(row) {
        return (
            <Row className="justify-content-md-center" style={{}}>
              <Button icon="pi pi-pencil" rounded severity="success" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
              <Button icon="pi pi-trash" rounded severity="danger" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
            </Row>
        );
    }

    return(      
      <>   
      <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>کلید های ارسال پیامک</div>
      <div className="" style={{ width:"calc(100% - 0px)"}}>
        <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
            <Row>
              <Col md={3}>
                <SchoolCombo returnFullItem={true} includeActive={true} includeInActive={false} value={searchSchool} onChange={(val) => onComboChange('searchSchool', val)} degree={-1} fieldId={""}/>
              </Col>
              <Col md={3} style={{paddingTop:"30px"}}>
                <FloatLabel>
                    <InputText value={searchApiKey} onChange={(e)=>{onInputChange(e, "searchApiKey")}} id="title" keyfilter="" maxLength={100} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                    <label htmlFor="username">کلید ارسال پیامک</label>
                </FloatLabel>
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={{float:'right', margin:'10px', display:'block', direction:"ltr", textAlign:"right"}}>
                  <Button label="جستجو" icon="pi pi-search" onClick={()=>searchItems()} severity="primary" iconPos="right" />
                </div>
                
              </Col>
            </Row>
        </div>
      </div>
      <div className="card" style={{overflow:"scroll", marginTop:"10px"}}>
          {
            loading?
                    <DataTable value={LoadingRows}  className="p-datatable-striped">
                        <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
                        <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
                    </DataTable>
            :
              <>
                <div className='col-12' style={{overflowX:"hidden"}}>
                  <Row style={{}}>
                    <Col md={2}>
                      <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right", margin:"10px" }}>             
                        <Button label="افزودن به لیست" icon="pi pi-plus" onClick={()=>addNewItem()} severity="secondary" iconPos="right" />
                      </div>                
                    </Col>
                  </Row>
                
                  <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                  dataKey="id"  selection={currentItem}  onSelectionChange={(e) => {setCurrentItem(e.value)}}>
                          <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                          <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                          {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                          <Column field="school.organizationCode" body={(row)=>{ return(<>{row.school.organizationCode}</>)}} header={"کد مدرسه"} sortable className="list-cell-text-align"></Column>
                          <Column field="school.schoolName" body={(row)=>{ return(<>{row.school.schoolName}</>)}} header={"مدرسه"} sortable className="list-cell-text-align"></Column>
                          <Column field="user.lastname" body={(row)=>{ return(<>{row.user.firstname + " " + row.user.lastname}</>)}} header={"کاربر"} sortable className="list-cell-text-align"></Column>
                          <Column field="apiKey" header={"کلید ارسال پیامک"} sortable className="list-cell-text-align"></Column>
                          <Column body={(row) => setRowActions(row)} exportable={false} style={{ width: '260px' }}></Column>
                  </DataTable>
                </div>
              </>
          }           
       </div>
       {
        editFormVisible?
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="ثبت مشخصات پنل پیامکی" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
              <table style={{width:"100%"}}>
                <tbody>
                  <tr><td>&nbsp;</td></tr>
                  <tr>
                    <td style={{padding:"1px"}}>
                      <SchoolCombo returnFullItem={true} includeActive={true} includeInActive={false} value={school} onChange={(val) => onComboChange('school', val)} />
                    </td>
                  </tr>
                  <tr><td>&nbsp;</td></tr>
                  <tr>
                    <td style={{padding:"1px"}}>
                      <FloatLabel>
                          <InputText value={apiKey} onChange={(e)=>{onInputChange(e, "apiKey")}} id="title" keyfilter="" maxLength={100} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                          <label htmlFor="username">کلید ارسال پیامک</label>
                      </FloatLabel>
                    </td>
                  </tr>
                  <tr><td>&nbsp;</td></tr>
                </tbody>
              </table>

        </Dialog>
        :
        <></>
       }
      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
      </>  
    );
}
